/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {EventEmitter} from '@angular/core';
import {NameValue} from '../tool/name-value';

enum LoaderState {
  waiting = 'waiting',
  success = 'success',
  error = 'error'
}
export class LoaderStateManager {
  private status = LoaderState.waiting;
  private message = null;
  private observable = new EventEmitter<NameValue>();

  public success(message: string) {
    this.status = LoaderState.success;
    this.message = message;
    this.observable.emit(new NameValue(this.status, this.message));
  }

  public error(message: string) {
    this.status = LoaderState.error;
    this.message = message;
    this.observable.emit(new NameValue(this.status, this.message));
  }

  public reload() {
    this.message = null;
    this.status = LoaderState.waiting;
    this.observable.emit(new NameValue(this.status, this.message));
  }

  public subscribe(f: (state: NameValue) => void) {
    this.observable.subscribe(f);
  }
}
